"use client";

import dynamic from "next/dynamic";

export const MusicWrapper = dynamic(() => import("./Music").then(mod => mod.Music));
